import { selector } from '@/lib/selectors';
import { isDocumentConfidentialSelector } from '@/domain/documents/documentSelector';

// Confidential documents are open to the confidential-user and accountant roles only.
export const approvalCandidateUsersSelector = selector(
  (state) => state.chat.users,
  isDocumentConfidentialSelector,
  (users, isDocumentConfidential) =>
    isDocumentConfidential
      ? users.filter((user) => ['confidential-user', 'accountant'].includes(user.role))
      : users.filter(({ role }) => role !== 'supplier'),
);
